import React from "react";
import { TagInput } from "rsuite";
import { Uploader } from "rsuite";
import { Button, Upload } from "antd";
import { useTheme } from "@mui/material/styles";
import Box from "@mui/material/Box";
import OutlinedInput from "@mui/material/OutlinedInput";
import InputLabel from "@mui/material/InputLabel";
import MenuItem from "@mui/material/MenuItem";
import FormControl from "@mui/material/FormControl";
import Select from "@mui/material/Select";
import Chip from "@mui/material/Chip";
import { FaCaretDown } from "react-icons/fa";
import { Dropdown } from 'primereact/dropdown';

const ITEM_HEIGHT = 48;
const ITEM_PADDING_TOP = 8;
const MenuProps = {
  PaperProps: {
    style: {
      maxHeight: ITEM_HEIGHT * 4.5 + ITEM_PADDING_TOP,
      width: 250,
    },
  },
};

const names = [
  "General Physician",
  "Cardiologist",
  "Dermatologist",
  "Neurologist",
  "Orthopedic Surgeon",
  "Pediatrician",
  "Psychiatrist",
  "Gynecologist",
  "Oncologist",
  "ENT Specialist",
  "Ophthalmologist",
  "Dentist",
  "Radiologist",
  "Anesthesiologist",
  "Gastroenterologist",
  "Nephrologist",
  "Urologist",
  "Endocrinologist",
  "Pulmonologist",
  "Rheumatologist",
  "Hematologist",
  "Plastic Surgeon",
  "General Surgeon",
  "Neurosurgeon",
  "Cosmetologist",
  "Pathologist",
  "Sexologist",
  "Allergist/Immunologist",
  "Diabetologist",
  "Laparoscopic Surgeon",
  "Internal Medicine Specialist",
  "Homeopathic Doctor",
  "Ayurvedic Doctor",
  "Unani Practitioner",
  "Occupational Therapist",
  "Physiotherapist",
];

function getStyles(name, personName, theme) {
  return {
    fontWeight: personName.includes(name)
      ? theme.typography.fontWeightMedium
      : theme.typography.fontWeightRegular,
  };
}

function PatientCareMedicalInfo({ formik }) {
const data = [
  "Hypertension (High Blood Pressure)",
  "Coronary Artery Disease (CAD)",
  "Heart Failure",
  "Atrial Fibrillation",
  "Myocardial Infarction (Heart Attack)",
  "Hyperlipidemia (High Cholesterol)",
  "Peripheral Artery Disease",
  "Arrhythmia",
  "Stroke",
  "Congenital Heart Disease",
  "Asthma",
  "Chronic Obstructive Pulmonary Disease (COPD)",
  "Tuberculosis",
  "Pneumonia",
  "Pulmonary Embolism",
  "Interstitial Lung Disease",
  "Sleep Apnea",
  "Bronchitis",
  "Gastritis",
  "Gastroesophageal Reflux Disease (GERD)",
  "Peptic Ulcer",
  "Irritable Bowel Syndrome (IBS)",
  "Crohn’s Disease",
  "Ulcerative Colitis",
  "Hepatitis B",
  "Hepatitis C",
  "Cirrhosis",
  "Fatty Liver Disease",
  "Pancreatitis",
  "Gallstones",
  "Epilepsy",
  "Migraine",
  "Stroke (Ischemic or Hemorrhagic)",
  "Parkinson’s Disease",
  "Alzheimer’s Disease",
  "Multiple Sclerosis",
  "Neuropathy",
  "Bell’s Palsy",
  "Osteoarthritis",
  "Rheumatoid Arthritis",
  "Osteoporosis",
  "Gout",
  "Low Back Pain",
  "Spondylitis",
  "Fractures (History of)",
  "Diabetes Mellitus Type 1",
  "Diabetes Mellitus Type 2",
  "Hypothyroidism",
  "Hyperthyroidism",
  "Polycystic Ovary Syndrome (PCOS)",
  "Metabolic Syndrome",
  "Addison’s Disease",
  "Cushing’s Syndrome",
  "HIV/AIDS",
  "Malaria",
  "Dengue",
  "Typhoid Fever",
  "COVID-19",
  "Influenza",
  "Hepatitis A/B/C",
  "Anemia",
  "Thalassemia",
  "Hemophilia",
  "Leukemia",
  "Lymphoma",
  "Sickle Cell Disease",
  "Depression",
  "Anxiety Disorder",
  "Bipolar Disorder",
  "Schizophrenia",
  "PTSD (Post-Traumatic Stress Disorder)",
  "OCD (Obsessive-Compulsive Disorder)",
  "Pregnancy",
  "Ectopic Pregnancy",
  "Preeclampsia",
  "Gestational Diabetes",
  "Menstrual Irregularities",
  "Infertility",
  "Eczema",
  "Psoriasis",
  "Acne",
  "Urticaria (Hives)",
  "Vitiligo",
  "Skin Cancer",
  "Cataract",
  "Glaucoma",
  "Diabetic Retinopathy",
  "Macular Degeneration",
  "Conjunctivitis",
  "Sinusitis",
  "Otitis Media",
  "Tinnitus",
  "Tonsillitis",
  "Deviated Nasal Septum",
  "Obesity",
  "Cancer (General or Site-specific)",
  "Autoimmune Disease",
  "Chronic Pain",
  "Fever (of unknown origin)",
  "Dehydration",
  "Sepsis",
  "Allergies (as separate list)",
  "No Known Medical Conditions",
  "Condition Not Documented",
  "None"
];


const allergyOptions = data.map(item => ({
  label: item,
  value: item
}));
  
  const multiselectstyles = `
  .css-yi3mkw {
      height: auto;
    min-height: 1.4375em;
    text-overflow: ellipsis;
    white-space: nowrap;
    overflow: hidden;
    flex-wrap: nowrap;
  }
  .p-inputtext{
  font-size:14px;
  color:#000;
  font-weight:300
  }
  `;

  const theme = useTheme();
  const [personName, setPersonName] = React.useState([]);

  const handleChange = (event) => {
    const {
      target: { value },
    } = event;
    setPersonName(
      // On autofill we get a stringified value.
      typeof value === "string" ? value.split(",") : value
    );
  };
  return (
    <>
      <style>{multiselectstyles}</style>
      <div className="row">
        <div className="col-12 d-flex flex-column align-items-start">
          <div className="col-12 d-flex">
            <h5
              className="fw-semibold h5-WOeTzEASAL"
              style={{ color: "rgb(43, 81, 147)", marginTop: "1rem" }}
            >
              Medical Information
            </h5>
          </div>
        </div>

        <div
          class="row mb-3"
          style={{ borderBottom: "1px dashed gray", paddingBottom: "1rem" }}
        >
          <div class="col-md-3 col-12">
            <div class="input-block mb-3">
              <label class="col-form-label lbl-VLJQLgvYMk">
                Admission Type<span className="text-danger">*</span>
              </label>

              <div style={{ position: "relative" }}>
                <select
                  class="form-control"
                  id="admissionType"
                  aria-hidden="true"
                  value={formik.values.addmissiontype}
                  onChange={formik.handleChange}
                  onBlur={formik.handleBlur}
                  name="addmissiontype"
                >
                  <option value="">Select the Options</option>
                  <option value="inpatient">In-Patient</option>
                  <option value="outpatient">Out-Patient</option>
                </select>
                <FaCaretDown
                  style={{
                    position: "absolute",
                    right: "10px",
                    top: "50%",
                    transform: "translateY(-50%)",
                    pointerEvents: "none",
                    color: "#666",
                    fontSize: "1rem",
                  }}
                />
              </div>
              {formik.touched.addmissiontype &&
                formik.errors.addmissiontype && (
                  <div style={{ fontSize: "0.8rem", color: "red" }}>
                    {formik.errors.addmissiontype}
                  </div>
                )}
            </div>
          </div>

          <div className="col-md-3 col-12">
  <div className="input-block mb-3">
    <label className="col-form-label lbl-VLJQLgvYMk">
      Allergies (if any)
    </label>
    <Dropdown
  name="allergiesifany"
  value={formik.values.allergiesifany}
  onChange={(e) => formik.setFieldValue('allergiesifany', e.value)}
  onBlur={formik.handleBlur}
  options={allergyOptions}
  placeholder="Select Allergy"
  className="w-full md:w-10rem border p-0 text-sm h-8"
  panelClassName="text-sm"
  style={{ fontSize: '0.6rem', minHeight: '40px', borderRadius:'10px'}}
  inputStyle={{ fontSize: '0.4rem' }}
  filter
  showClear
/>

    {formik.touched.allergiesifany && formik.errors.allergiesifany && (
      <div style={{ fontSize: '0.8rem', color: 'red', marginTop: '3px' }}>
        {formik.errors.allergiesifany}
      </div>
    )}
  </div>
</div>

          <div class="col-md-3 col-12">
            <div class="input-block mb-3">
              <label class="col-form-label lbl-VLJQLgvYMk">
                Existing Medical Conditions
                <span className="text-danger">*</span>
              </label>
              <div style={{ position: "relative" }}>
                <select
                  class="form-control"
                  id="Gender"
                  aria-hidden="true"
                  value={formik.values.existingmedicalconditions}
                  onChange={formik.handleChange}
                  onBlur={formik.handleBlur}
                  name="existingmedicalconditions"
                >
                  <option value="">Select the Options</option>
                  <option value="none">None</option>
                  <option value="diabetes">Diabetes</option>
                  <option value="hypertension">Hyper Tension</option>
                </select>
                <FaCaretDown
                  style={{
                    position: "absolute",
                    right: "10px",
                    top: "50%",
                    transform: "translateY(-50%)",
                    pointerEvents: "none",
                    color: "#666",
                    fontSize: "1rem",
                  }}
                />
              </div>
              {formik.touched.existingmedicalconditions &&
                formik.errors.existingmedicalconditions && (
                  <div style={{ fontSize: "0.8rem", color: "red" }}>
                    {formik.errors.existingmedicalconditions}
                  </div>
                )}
            </div>
          </div>
        </div>

        {/* <div className="col-md-3 col-12">
          <div className="input-block mb-3">
            <label className="col-form-label lbl-VLJQLgvYMk">
              Medications Prescribed<span className="text-danger">*</span>
            </label>
            <input
              type="text"
              className="form-control"
              placeholder="Enter Medications Prescribed"
              value={formik.values.medicationsprescribed}
              name="medicationsprescribed"
              onChange={formik.handleChange}
              onBlur={formik.handleBlur}
            />
            {formik.touched.medicationsprescribed && formik.errors.medicationsprescribed && (
              <div style={{ fontSize: "0.8rem", color: "red" }}>
                {formik.errors.medicationsprescribed}
              </div>
            )}
          </div>
        </div>

              <div class="col-12 col-md-4">
                <div class="mb-3">
                  <div className="d-flex align-items-center w-50 gap-2 div-kasxoakxm">
                    <label class="col-form-label abt-pr">
                      {" "}
                     Primary Diagnosis<span class="text-danger">*</span>{" "}
                    </label>
                    
                  </div>
                  <textarea
                    class="form-control"
                    placeholder=""
                    style={{
                      color: "rgb(66, 66, 66)",
                      height: "70px",
                      letterSpacing: "0.5px",
                      fontSize: "0.9rem",
                      padding: "0.8rem",
                      lineHeight: "1.7",
                    }}
                    name="primarydiagnosis"
                    value={formik.values.primarydiagnosis}
                    onChange={formik.handleChange}
                    onBlur={formik.handleBlur}
                  ></textarea>

                  {formik.touched.primarydiagnosis && formik.errors.primarydiagnosis && (
                    <div style={{ fontSize: "0.8rem", color: "red" }}>
                      {formik.errors.primarydiagnosis}
                    </div>
                  )}
                </div>
              </div>

              <div class="col-12 col-md-4">
                <div class="mb-3">
                  <div className="d-flex align-items-center w-50 gap-2 div-kasxoakxm">
                    <label class="col-form-label abt-pr">
                      {" "}
                     Symptons<span class="text-danger">*</span>{" "}
                    </label>
                    
                  </div>
                  <textarea
                    class="form-control"
                    placeholder=""
                    style={{
                      color: "rgb(66, 66, 66)",
                      height: "70px",
                      letterSpacing: "0.5px",
                      fontSize: "0.9rem",
                      padding: "0.8rem",
                      lineHeight: "1.7",
                    }}
                    name="symptons"
                    value={formik.values.symptons}
                    onChange={formik.handleChange}
                    onBlur={formik.handleBlur}
                  ></textarea>

                  {formik.touched.symptons && formik.errors.symptons && (
                    <div style={{ fontSize: "0.8rem", color: "red" }}>
                      {formik.errors.symptons}
                    </div>
                  )}
                </div>
              </div>

              <div class="col-12 col-md-4">
                <div class="mb-3">
                  <div className="d-flex align-items-center w-100 gap-2 div-kasxoakxm">
                    <label class="col-form-label abt-pr">
                      {" "}
                     Treatment Plan Summary<span class="text-danger">*</span>{" "}
                    </label>
                    
                  </div>
                  <textarea
                    class="form-control"
                    placeholder=""
                    style={{
                      color: "rgb(66, 66, 66)",
                      height: "70px",
                      letterSpacing: "0.5px",
                      fontSize: "0.9rem",
                      padding: "0.8rem",
                      lineHeight: "1.7",
                    }}
                    name="treatmentplansummary"
                    value={formik.values.treatmentplansummary}
                    onChange={formik.handleChange}
                    onBlur={formik.handleBlur}
                  ></textarea>

                  {formik.touched.treatmentplansummary && formik.errors.treatmentplansummary && (
                    <div style={{ fontSize: "0.8rem", color: "red" }}>
                      {formik.errors.treatmentplansummary}
                    </div>
                  )}
                </div>
              </div>

              

        <div className="col-md-3 col-12">
          <div className="input-block mb-3">
            <label className="col-form-label lbl-VLJQLgvYMk">
            Lab/Diagnostic Tests Ordered<span className="text-danger">*</span>
            </label>
            <input
              type="text"
              className="form-control"
              placeholder="Enter Lab Tests"
              value={formik.values.labdiagnostictestsordered}
              name="labdiagnostictestsordered"
              onChange={formik.handleChange}
              onBlur={formik.handleBlur}
            />
            {formik.touched.labdiagnostictestsordered && formik.errors.labdiagnostictestsordered && (
              <div style={{ fontSize: "0.8rem", color: "red" }}>
                {formik.errors.labdiagnostictestsordered}
              </div>
            )}
          </div>
        </div>

        <div className="col-md-3 col-12">
          <div className="input-block mb-3">
            <label className="col-form-label lbl-VLJQLgvYMk">
            Room/Ward Number (if In-Patient)<span className="text-danger">*</span>
            </label>
            <input
              type="text"
              className="form-control"
              placeholder="Enter Room/Ward Number"
              value={formik.values.roomwardnumber}
              name="roomwardnumber"
              onChange={formik.handleChange}
              onBlur={formik.handleBlur}
            />
            {formik.touched.roomwardnumber && formik.errors.roomwardnumber && (
              <div style={{ fontSize: "0.8rem", color: "red" }}>
                {formik.errors.roomwardnumber}
              </div>
            )}
          </div>
        </div> */}

        <h5>Vitals</h5>
        <div class="col-md-3 col-12">
          <div class="input-block mb-3">
            <label class="col-form-label lbl-VLJQLgvYMk">Blood Group</label>

            <div style={{ position: "relative" }}>
              <select
                class="form-control"
                id="bloodgroup"
                aria-hidden="true"
                value={formik.values.bloodgroup}
                onChange={formik.handleChange}
                onBlur={formik.handleBlur}
                name="bloodgroup"
              >
                <option value="">Select Blood Group</option>
                <option value="A+">A+</option>
                <option value="A-">A-</option>
                <option value="B+">B+</option>
                <option value="B-">B-</option>
                <option value="AB+">AB+</option>
                <option value="AB-">AB-</option>
                <option value="O+">O+</option>
                <option value="O-">O-</option>
              </select>
              <FaCaretDown
                style={{
                  position: "absolute",
                  right: "10px",
                  top: "50%",
                  transform: "translateY(-50%)",
                  pointerEvents: "none",
                  color: "#666",
                  fontSize: "1rem",
                }}
              />
            </div>
            {formik.touched.bloodgroup && formik.errors.bloodgroup && (
              <div style={{ fontSize: "0.8rem", color: "red" }}>
                {formik.errors.bloodgroup}
              </div>
            )}
          </div>
        </div>

        <div class="col-md-3 col-12">
          <div class="input-block mb-3">
            <label class="col-form-label lbl-VLJQLgvYMk">
              Blood Pressure
            </label>
            <div style={{ position: "relative" }}>
              <input
                type="text"
                className="form-control"
                placeholder="Enter Blood Pressure"
                value={formik.values.bloodpressure}
                name="bloodpressure"
                onChange={(e) => {
                  const cleanedValue = e.target.value.replace(/[^0-9/]/g, "");
                  formik.setFieldValue("bloodpressure", cleanedValue);
                }}
                onBlur={formik.handleBlur}
                style={{ paddingRight: "2.5rem" }}
              />

              <span
                style={{
                  position: "absolute",
                  right: "10px",
                  top: "50%",
                  transform: "translateY(-50%)",
                  pointerEvents: "none",
                  color: "#666",
                  fontSize: "1rem",
                }}
              >
                mmHg
              </span>
            </div>
            {formik.touched.bloodpressure && formik.errors.bloodpressure && (
              <div style={{ fontSize: "0.8rem", color: "red" }}>
                {formik.errors.bloodpressure}
              </div>
            )}
          </div>
        </div>

        {/* <div className="col-md-3 col-12">
  <div className="input-block mb-3" style={{ position: "relative" }}>
    <label className="col-form-label lbl-VLJQLgvYMk">
      Weight<span className="text-danger">*</span>
    </label>

    <input
      type="text"
      className="form-control"
      placeholder="Enter Weight"
      value={formik.values.allergiesifany}
      name="allergiesifany"
      onChange={formik.handleChange}
      onBlur={formik.handleBlur}
      style={{ paddingRight: "2.5rem" }} 
    />
    <span
      style={{
                  position: "absolute",
                  right: "10px",
                  top: "80%",
                  transform: "translateY(-50%)",
                  pointerEvents: "none",
                  color: "#666",
                  fontSize: "1rem",
                }}
    >
      cm
    </span>
    {formik.touched.allergiesifany && formik.errors.allergiesifany && (
      <div style={{ fontSize: "0.8rem", color: "red" }}>
        {formik.errors.allergiesifany}
      </div>
    )}
  </div>
</div> */}
        <div class="col-md-3 col-12">
          <div class="input-block mb-3">
            <label class="col-form-label lbl-VLJQLgvYMk">
              Weight
            </label>
            <div style={{ position: "relative" }}>
              <input
                type="text"
                className="form-control"
                placeholder="Enter Weight"
                value={formik.values.weight}
                name="weight"
                onChange={(e) => {
                  const cleanedValue = e.target.value.replace(/[^0-9]/g, "");
                  formik.setFieldValue("weight", cleanedValue);
                }}
                onBlur={formik.handleBlur}
                style={{ paddingRight: "2.5rem" }}
              />

              <span
                style={{
                  position: "absolute",
                  right: "10px",
                  top: "50%",
                  transform: "translateY(-50%)",
                  pointerEvents: "none",
                  color: "#666",
                  fontSize: "1rem",
                }}
              >
                kg
              </span>
            </div>
            {formik.touched.weight && formik.errors.weight && (
              <div style={{ fontSize: "0.8rem", color: "red" }}>
                {formik.errors.weight}
              </div>
            )}
          </div>
        </div>

        <div class="col-md-3 col-12">
          <div class="input-block mb-3">
            <label class="col-form-label lbl-VLJQLgvYMk">Height</label>
            <div style={{ position: "relative" }}>
              <input
                type="text"
                className="form-control"
                placeholder="Enter Height"
                value={formik.values.height}
                name="height"
                onChange={(e) => {
                  const cleanedValue = e.target.value.replace(/[^0-9]/g, "");
                  formik.setFieldValue("height", cleanedValue);
                }}
                onBlur={formik.handleBlur}
                style={{ paddingRight: "2.5rem" }}
              />

              <span
                style={{
                  position: "absolute",
                  right: "10px",
                  top: "50%",
                  transform: "translateY(-50%)",
                  pointerEvents: "none",
                  color: "#666",
                  fontSize: "1rem",
                }}
              >
                cm
              </span>
            </div>
            {formik.touched.height && formik.errors.height && (
              <div style={{ fontSize: "0.8rem", color: "red" }}>
                {formik.errors.height}
              </div>
            )}
          </div>
        </div>

        <div class="col-md-3 col-12">
          <div class="input-block mb-3">
            <label class="col-form-label lbl-VLJQLgvYMk">
              Pulse
            </label>
            <div style={{ position: "relative" }}>
              <input
                type="text"
                className="form-control"
                placeholder="Enter Pulse"
                value={formik.values.pulse}
                name="pulse"
                onChange={(e) => {
                  const cleanedValue = e.target.value.replace(/[^0-9]/g, "");
                  formik.setFieldValue("pulse", cleanedValue);
                }}
                onBlur={formik.handleBlur}
                style={{ paddingRight: "2.5rem" }}
              />

              <span
                style={{
                  position: "absolute",
                  right: "10px",
                  top: "50%",
                  transform: "translateY(-50%)",
                  pointerEvents: "none",
                  color: "#666",
                  fontSize: "1rem",
                }}
              >
                bpm
              </span>
            </div>
            {formik.touched.pulse && formik.errors.pulse && (
              <div style={{ fontSize: "0.8rem", color: "red" }}>
                {formik.errors.pulse}
              </div>
            )}
          </div>
        </div>

        <div class="col-md-3 col-12">
          <div class="input-block mb-3">
            <label class="col-form-label lbl-VLJQLgvYMk">
              Temparature<span className="text-danger">*</span>
            </label>
            <div style={{ position: "relative" }}>
              <input
                type="text"
                className="form-control"
                placeholder="Enter Temperature"
                value={formik.values.temparature}
                name="temparature"
                onChange={(e) => {
                  const cleanedValue = e.target.value.replace(/[^0-9.]/g, "");
                  formik.setFieldValue("temparature", cleanedValue);
                }}
                onBlur={formik.handleBlur}
                style={{ paddingRight: "2.5rem" }}
              />

              <span
                style={{
                  position: "absolute",
                  right: "10px",
                  top: "50%",
                  transform: "translateY(-50%)",
                  pointerEvents: "none",
                  color: "#666",
                  fontSize: "1rem",
                }}
              >
                °C
              </span>
            </div>
            {formik.touched.temparature && formik.errors.temparature && (
              <div style={{ fontSize: "0.8rem", color: "red" }}>
                {formik.errors.temparature}
              </div>
            )}
          </div>
        </div>
      </div>
    </>
  );
}

export default PatientCareMedicalInfo;
